export type FocusableElement = HTMLElement | SVGElement;

export function captureFocusedElement(): FocusableElement | null {
  const active = document.activeElement;
  if (active instanceof HTMLElement || active instanceof SVGElement) {
    return active;
  }
  return null;
}

export function blurFocusedElement(element: FocusableElement | null) {
  element?.blur();
}

export function restoreFocusToElement(element: FocusableElement | null) {
  if (!element || !document.contains(element)) return;
  element.focus();
}
